import { render, staticRenderFns } from "./ZhusuRetu.vue?vue&type=template&id=1b63720e&scoped=true&"
import script from "./ZhusuRetu.vue?vue&type=script&lang=js&"
export * from "./ZhusuRetu.vue?vue&type=script&lang=js&"
import style0 from "./ZhusuRetu.vue?vue&type=style&index=0&id=1b63720e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b63720e",
  null
  
)

export default component.exports